module.exports = __webpack_public_path__ + "static/img/model-4.58cb0a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/model-4.gif
// module id = OB/m
// module chunks = 0